import { createSelector } from 'reselect';

const selectSubCategories = (state: any) => state.subCategories;


export const selectSubCategoriesCurrentItem = createSelector([selectSubCategories], (subCategories) => subCategories.current);

export const selectSubCategoriesListItems = createSelector([selectSubCategories], (subCategories) => subCategories.list);

export const selectSubCategoriesItemById = (itemId: any) =>
    createSelector(selectSubCategoriesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectSubCategoriesQueryItems = createSelector([selectSubCategories], (subCategories) => subCategories.query);

export const selectSubCategoriesCreatedItem = createSelector([selectSubCategories], (subCategories) => subCategories.create);

export const selectSubCategoriesUpdatedItem = createSelector([selectSubCategories], (subCategories) => subCategories.update);

export const selectSubCategoriesReadItem = createSelector([selectSubCategories], (subCategories) => subCategories.read);

export const selectSubCategoriesDeletedItem = createSelector([selectSubCategories], (subCategories) => subCategories.delete);

export const selectSubCategoriesearchedItems = createSelector([selectSubCategories], (subCategories) => subCategories.search);

export const selectSubCategoriesItemsCount = createSelector([selectSubCategories], (subCategories) => subCategories.count);

export const selectSubCategoriesItemsFilter = createSelector([selectSubCategories], (subCategories) => subCategories.filter);